export default interface DYNAMIC_BUTTON
{
	ID                            : string;  // uniqueidentifier
	VIEW_NAME                     : string;  // nvarchar
	CONTROL_INDEX                 : number;  // int
	CONTROL_TYPE                  : string;  // nvarchar
	DEFAULT_VIEW                  : boolean; // bit
	MODULE_NAME                   : string;  // nvarchar
	MODULE_ACCESS_TYPE            : string;  // nvarchar
	TARGET_NAME                   : string;  // nvarchar
	TARGET_ACCESS_TYPE            : string;  // nvarchar
	MOBILE_ONLY                   : boolean; // bit
	ADMIN_ONLY                    : boolean; // bit
	EXCLUDE_MOBILE                : boolean; // bit
	CONTROL_TEXT                  : string;  // nvarchar
	CONTROL_TOOLTIP               : string;  // nvarchar
	CONTROL_ACCESSKEY             : string;  // nvarchar
	CONTROL_CSSCLASS              : string;  // nvarchar
	TEXT_FIELD                    : string;  // nvarchar
	ARGUMENT_FIELD                : string;  // nvarchar
	COMMAND_NAME                  : string;  // nvarchar
	URL_FORMAT                    : string;  // nvarchar
	URL_TARGET                    : string;  // nvarchar
	ONCLICK_SCRIPT                : string;  // nvarchar
	HIDDEN                        : boolean; // bit
	BUSINESS_RULE                 : string;  // nvarchar
	BUSINESS_SCRIPT               : string;  // nvarchar
	MODULE_ACLACCESS              : string;
	TARGET_ACLACCESS              : string;
}

